<template>
    <v-container fluid>
        <v-layout row wrap align-center>
            <div class="display-1">{{ $t('dashboard') | capitalize }}</div>
            <v-spacer></v-spacer>
            <div>
                <v-select
                    :label="$t('interval') | capitalize"
                    v-model="chartInterval"
                    :items="chartIntervalList"
                    item-disabled="disabled"
                ></v-select>
            </div>
            <TimeRangePicker v-model="filterDateRange" ref="TimeRangePicker"></TimeRangePicker>
        </v-layout>
        <v-alert
            class="text-md-left"
            :value="showAlert"
            type="info"
            transition="scale-transition"
            color="grey"
            align-left
        >
            {{ $t('projectDashboard.noApiAvailable') }}
            <router-link :to="{ name: 'apis', params: { project_id: $route.params.project_id }}">APIs</router-link>
            .
        </v-alert>
        <v-layout row wrap v-if="dataApiUsage.length > 0">
            <v-flex xl4 lg4 md12 sm12 xs12>
                <p class="pa-2 title">{{ $t('traffic') | capitalizeAll }}</p>
                <UsageChart
                    :data=dataAnalytics
                    :time-range=chartTimeRange
                    :interval=chartInterval
                ></UsageChart>
            </v-flex>
            <v-flex xl4 lg4 md12 sm12 xs12>
                <p class="pa-2 title">{{ $t('errors') | capitalizeAll }}</p>
                <UsageChart
                    :data=dataError
                    :time-range=chartTimeRange
                    :interval=chartInterval
                ></UsageChart>
            </v-flex>
            <v-flex xl4 lg4 md12 sm12 xs12>
                <p class="pa-2 title">{{ $t('medianLatency') | capitalizeAll }} (ms)</p>
                <LatencyChart
                    :data="medianLatency"
                    :time-range="chartTimeRange"
                    :interval="chartInterval"
                ></LatencyChart>
            </v-flex>
        </v-layout>
        <div v-if="dataApiUsage.length > 0">
            <div class="title pa-2">
                APIs
            </div>
            <div>
                <DataTable :items="dataApiUsage" @open-api-pricing="openApiPricing($event)"></DataTable>
            </div>
        </div>
        <ApiPricing ref="ApiPricing" :apiCode="apiCodePricing" :apiName="apiNamePricing"></ApiPricing>
    </v-container>
</template>

<script>
import UsageChart from '@/views/Dashboard/UsageChart'
import LatencyChart from '@/views/Dashboard/LatencyChart'
import DataTable from './DataTable.vue'
import TimeRangePicker from '@/modules/fptai/components/TimeRangePicker'
import DashboardService from '@/services/dashboard.service'
import ApiPricing from '@/components/ApiPricing.vue'
import DashboardMixin from '@/views/Dashboard/DashboardMixin'

export default {
    name: 'Dashboard',
    components: {
        DataTable,
        ApiPricing,
        TimeRangePicker,
        UsageChart,
        LatencyChart
    },
    mixins: [DashboardMixin],
    data () {
        return {
            dataAnalytics: [],
            dataError: [],
            medianLatency: [],
            dataApiUsage: [],
            showAlert: false,
            interval: null,
            apiCodePricing: '',
            apiNamePricing: '',
            chartTimeRange: null
        }
    },
    mounted () {
        this.getDataDashboard()
        this.interval = setInterval(this.getDataDashboard, 10000)
        if (this.$route.query.pricing === 'on') {
            let apiCode = this.$route.query.apiCode
            let apiName = this.$route.query.apiName
            this.openApiPricing({ apiCode, apiName })
        }
    },
    destroyed () {
        clearInterval(this.interval)
    },
    methods: {
        getDataDashboard () {
            this.chartTimeRange = this.$refs.TimeRangePicker.getTimestamp()
            DashboardService.getDataAnalytics(
                this.$route.params.project_id,
                this.chartTimeRange,
                this.chartInterval
            ).then(
                dataRes => {
                    this.chartIntervalList = this.$refs.TimeRangePicker.getIntervalList()
                    this.chartInterval = this.$refs.TimeRangePicker.getPreferInterval(this.chartInterval)
                    if (dataRes.status) {
                        this.dataAnalytics = dataRes.data.data
                        this.dataError = dataRes.data.data_error
                        this.dataApiUsage = dataRes.data.data_table
                        this.medianLatency = dataRes.data.data_median_latency
                        this.showAlert = this.dataApiUsage.length === 0
                    } else {
                        this.dataAnalytics = []
                        this.dataError = []
                        this.dataApiUsage = []
                        this.medianLatency = []
                    }
                },
                this.$appService.handleRequestError(this.$t('actionFailed', {
                    action: this.$t('load'),
                    item: this.$t('data')
                }))
            )
        },
        async openApiPricing ({ apiCode, apiName }) {
            this.apiCodePricing = apiCode
            this.apiNamePricing = apiName
            this.$nextTick(async () => {
                await this.$refs.ApiPricing.getApiInfo()
                this.$refs.ApiPricing.openDialog()
            })
        }
    }
}
</script>
